import { render } from "./prio-med.vue?vue&type=template&id=4f4db69b"
import script from "./prio-med.vue?vue&type=script&lang=js"
export * from "./prio-med.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__